module.exports = __webpack_public_path__ + "static/media/analytics-logo.b78f70d1.svg";